import React from 'react';

type HomeSectionProps = {
  title: string;
  description?: string;
  extraContainerClassNames?: string;
  h3?: boolean;
};

const HomeSection: React.FC<HomeSectionProps> = ({
  title,
  description,
  extraContainerClassNames,
  h3,
  children,
}) => {
  return (
    <div
      className={`mx-auto flex w-full flex-col items-center py-4 text-left sm:py-12 ${
        extraContainerClassNames || ''
      }`}
    >
      <div className={`${children ? 'my-10' : ''} flex flex-col items-start`}>
        {h3 && (
          <h2 className="w-full text-xl font-semibold leading-7 text-gray-900 dark:text-gray-100 sm:text-3xl md:leading-10 xl:text-4xl">
            {title}
          </h2>
        )}
        {!h3 && (
          <h2 className="w-full text-2xl font-bold leading-7 text-primary-900 dark:text-gray-100 sm:text-4xl md:leading-10 xl:text-5xl">
            {title}
          </h2>
        )}
        {description && (
          <p className="mt-5 text-lg font-medium text-gray-900 sm:mt-10 sm:text-xl">
            {description}
          </p>
        )}
      </div>
      {children && (
        <div className="flex w-full max-w-full flex-col items-center justify-center">
          {children}
        </div>
      )}
    </div>
  );
};

export default HomeSection;
